import { httpService } from 'common/api';
import { config } from 'config';

class AuthService {
    authenticate(username, password) {
        var appId = config.appId;
        const headers = new Headers();
        headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        const body = {
            username,
            password,
            appId,
            grant_type: 'password'
        };

        return httpService.request('token', 'POST', {
            headers,
            body: transformData(body)
        });
    }

    logout() {

    }

    async getUser() {
        try {
            return httpService.get('user/user-info');
        } catch(e) {
            return null;
        }
    }
}

function transformData(data) {
    let items = [];
    for (let key in data) {
        items.push([encodeURIComponent(key), encodeURIComponent(data[key])].join('='))
    }
    return items.join('&');
}

const authService = new AuthService();
export { authService }


// WEBPACK FOOTER //
// ./src/common/security/authService.js